<script setup>
import { useMainStore } from '@/stores/store.js';
import StepsProgress from '@/components/StepsProgress.vue';
import { useRouter } from 'vue-router';

const store = useMainStore();
const router = useRouter();

const isDevelopment = import.meta.env.DEV;

const handleLogoClick = (event) => {
	event.preventDefault();
	store.gotoStep('Start', router, 'previous', 'click');
};
</script>

<template>

	<div class="absolute rounded-br-xs top-0 left-0 bg-white z-50 p-[3px] text-[10px] text-black leading-2 tracking-0" aria-hidden="true" v-if="isDevelopment">
		<!-- for development only -->
		<div class="sm:hidden md:hidden lg:hidden xl:hidden 2xl:hidden">XS</div>
		<div class="hidden sm:block md:hidden lg:hidden xl:hidden 2xl:hidden">SM</div>
		<div class="hidden md:block lg:hidden xl:hidden 2xl:hidden">MD</div>
		<div class="hidden lg:block xl:hidden 2xl:hidden">LG</div>
		<div class="hidden xl:block 2xl:hidden">XL</div>
		<div class="hidden 2xl:block">2XL</div>
		<!-- for development only -->
	</div>

	<header id="luxxbox-acoustic-analyzer-header" class="py-4 px-4 md:px-7 md:pl-8 pb-4 flex w-full flex-row items-center justify-between gap-x-3 ">
		<div class="flex-0 order-0">
			<a href="/">
				<img src="@/assets/luxxbox-logo.svg" alt="Luxxbox" class="h-[50px] w-[50px] min-w-[50px] sm:h-[80px] sm:w-[80px] sm:min-w-[50px]" />
			</a>
		</div>

		<div class="flex flex-1 flex-col gap-x-3 md:self-stretch sm:flex-row">
			<div class="flex-0 order-1 content-center pt-0 text-left text-sm font-medium uppercase tracking-wide sm:order-2 sm:text-right sm:text-sm sm:tracking-widest relative">
				<h1 class="font-extrabold relative">
					<span class="-my-[1px] sm:block">Luxxbox&nbsp;</span>
					<span class="-my-[1px] sm:block">Acoustic&nbsp;</span>
					<span class="-my-[1px] sm:block">Analyzer&nbsp;</span>
				</h1>
			</div>
			<div class="bg-1red-500 order-2 w-full flex-1 content-end self-stretch pt-0 sm:order-1 sm:content-start sm:pt-0">
				<StepsProgress />
			</div>
		</div>
	</header>
</template>

<style scoped></style>
